define('responsive-gameday/controllers/WrapupBoxScoreViewController',['require','exports','module','./BoxscoreViewController','message-service/message-service'],function(require,exports,module){
    // Add private variables here
    var BoxScoreViewController = require( "./BoxscoreViewController" ),
        MessageService = require("message-service/message-service");

    var renderers = null,
        Superclass;
    
    // Constructor
    function WrapupBoxScoreController(type) {
        // Call super constructor
        Superclass.constructor.call(this);
        this.referenceName = "WrapupBox";
        MessageService.publish("registerViewComponent", this);
    }

    // Prototype Inheritence
    BoxScoreViewController.spawn(WrapupBoxScoreController).define({
        loadView : function(){
            Superclass.loadView.call(this);
            this.setClassName("WrapupBoxScoreController wide-view");
            this.canScroll=false;
            this.showLinescore = false;
        }
    });

    Superclass = WrapupBoxScoreController.superclass;
    return WrapupBoxScoreController;
});
